/* src/app/practice-exams/practice-exams.component.scss */
span.bright {
  font-size: 2rem;
  font-weight: bold;
  color: #FF8B00;
}
/*# sourceMappingURL=/practice-exams.component.css.map */
